// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"c1-z"};